export default __webpack_public_path__ + "static/media/cash-pickup.590bd014.svg";